<template>
  <circle cx="8" cy="4" r="4" fill="#3769D6" />
  <path
    opacity="0.5"
    d="M2 15.25C2 12.3505 4.35051 10 7.25 10H8.75C11.6495 10 14 12.3505 14 15.25C14 15.6642 13.6642 16 13.25 16H2.75C2.33579 16 2 15.6642 2 15.25Z"
    fill="#3769D6"
  />
</template>
